<template>
  <v-container
    grid-list-md
  >
    <UserEditCondition
      :cond="cond"
    />
    <v-layout row>
      <v-flex
        md8
      >
        <MaterialCard
          color="green"
          full-width
        >
          <v-list>
            <v-list-tile
              v-for="user in users"
              :key="user.id"
            >
              <v-list-tile-action>
                <v-checkbox
                  v-model="user.active"
                  :true-value="true"
                  :falsy-value="false"
                />
              </v-list-tile-action>
              <v-list-tile-content>
                {{ user.name }}
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </MaterialCard>
      </v-flex>
      <v-flex
        md4
      >
        <my-role-edit-detail
          v-if="selected != null"
          :authority="selected"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { UserEditCondition } from './components'
// import MyUserEditDetail from './user-edit-detail'
// import { api } from '@/api'

export default {
  components: {
    UserEditCondition
  },
  async beforeRouteEnter (to, from, next) {
    try {
      const response = await search(to.query)
      next(vm => {
        vm.init(response)
      })
    } catch (e) {
      next(e)
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      const response = await search(to.query)
      this.init(response)
      next()
    } catch (e) {
      next(e)
    }
  },
  data: () => ({
    cond: {
      name: ''
    },
    allUsers: [],
    role: null,
    selected: null
  }),
  computed: {
    users () {
      if (this.cond.name === '') {
        return this.allUsers
      } else {
        const name = this.cond.name.toLowerCase()
        return this.allUsers.filter(u => u.name.toLowerCase().indexOf(name) !== -1)
      }
    }
  },
  methods: {
    init (value) {
      const { role, users } = value
      this.role = role
      this.allUsers = users.map(u => {
        const user = Object.assign({}, u)
        user.active = role.users.some(_u => u.id === _u.id)
        return user
      })
    },
    onRoleSelected (item) {
      this.selected = item
    }
  }
}

export const search = async (query) => {
  const response = {
    role: {
      id: 3,
      name: 'PartTimeJob',
      description: 'アルバイト',
      editable: true,
      users: [
        { id: 1, name: 'ユーザー1' },
        { id: 2, name: 'ユーザー2' }
      ],
      authorities: [ 1, 2, 3, 9, 12 ]
    },
    users: [
      { id: 1, name: 'ユーザー1' },
      { id: 2, name: 'ユーザー2' },
      { id: 3, name: 'ユーザー3' },
      { id: 4, name: 'ユーザー4' },
      { id: 5, name: 'ユーザー5' },
      { id: 6, name: 'ユーザー6' },
      { id: 7, name: 'ユーザー7' },
      { id: 8, name: 'ユーザー8' }
    ]
  }

  return response
}
</script>
